import { UserFilterOptions } from '../../../../types/user/UserFilterOptions';
import UserFilter from '../../../../types/user/UserFilters';
import UserFilterEnum from '../../../../types/user/UserFilterEnum';

export interface SearchState {
    data: UserFilterOptions;
    error: string;
    loading: boolean;
    filters: UserFilter;
}

export enum TypesEnum {
    optionsRequested = 'smoelenboek/search/OPTIONS_REQUESTED',
    optionsReceived = 'smoelenboek/search/OPTIONS_RECEIVED',
    optionsRequestFailed = 'smoelenboek/search/OPTIONS_REQUEST_FAILED',
    filterByChanged = 'smoelenboek/search/FILTER_BY_CHANGED',
    searchNameChanged = 'smoelenboek/search/SEARCH_NAME_CHANGED',
    optionTriggered = 'smoelenboek/search/OPTION_TRIGGERED',
    filtersReset = 'smoelenboek/search/FILTERS_RESET',
}

export interface OptionsRequestedAction {
    type: TypesEnum.optionsRequested;
}

export interface OptionsReceivedAction {
    type: TypesEnum.optionsReceived;
    payload: UserFilterOptions;
}

export interface OptionsRequestFailedAction {
    type: TypesEnum.optionsRequestFailed;
    payload: string;
}

export interface FilterByChangedAction {
    type: TypesEnum.filterByChanged;
    payload: UserFilterEnum;
}

export interface SearchNameChangedAction {
    type: TypesEnum.searchNameChanged;
    payload: string;
}

export interface OptionTriggeredAction {
    type: TypesEnum.optionTriggered;
    payload: string;
}

export interface FiltersResetAction {
    type: TypesEnum.filtersReset;
}

export type SearchActionTypes =
    | OptionsRequestedAction
    | OptionsReceivedAction
    | OptionsRequestFailedAction
    | FilterByChangedAction
    | SearchNameChangedAction
    | OptionTriggeredAction
    | FiltersResetAction;
